import React from "react";
import i18n from "i18next";

import CarouselButtons from "../carousel_buttons/CarouselButtons";
import CarouselHeader from "../carousel_header/CarouselHeader";
import FileTree from "../file_tree/FileTree";
// === Task 22 ===
import ComponentsNav from "../elements_library/ComponentsNav";
import LibraryPanel from "../library/LibraryPanel.jsx";
import AudioPanel from "../audio/AudioPanel.jsx";
import SceneAudioPanel from "../audio/SceneAudioPanel.jsx";
import LibraryPanels from "../../../containers/LibraryPanels";
import ComponentsPanels from "../elements_library/ComponentsPanels";
import { LuChevronLeft } from "react-icons/lu";
// Task 23 (Round 27 verify) — .left-rail--interactive-mode is declared in
// AssessmentsPanel.scss but is applied to ALL non-Interactive category panels
// at this level (Elements / Library / Audio / Assessments wrapper). Side-effect
// import here so the class is available even when AssessmentsPanel itself is
// not mounted (e.g. user has Elements open while an InteractivePlugin box is
// selected on the canvas).
import "../elements_library/panels/AssessmentsPanel.scss";

import { LEFT_PANEL_WIDTH, LEFT_PANEL_OVERLAY_WIDTH } from "../../../../common/layout_constants";
import { isClmCourse } from "../../../../common/clm";

// Re-exported Scenes-list width; per-panel widths live in layout_constants
// so this wrapper and EditorApp's #leftPanelContainer can never diverge.
export const LEFT_PANEL_EXPANDED_WIDTH_PX = LEFT_PANEL_WIDTH.scenes;
export const LEFT_PANEL_EXPANDED_WIDTH = `${LEFT_PANEL_EXPANDED_WIDTH_PX}px`;

/**
 * Index wrapper container
 */
const EditorCarousel = (props) => {
  const [selectedAudioOption, setSelectedAudioOption] = React.useState("scene-sounds");
  const {
    carouselShow,
    carouselFull,
    globalConfig,
    exercises,
    containedViews,
    containedViewSelected,
    boxes,
    navItemsIds,
    navItems,
    navItemSelected,
    indexSelected,
    viewToolbars,
    uploadedTemplates,
    onBoxAdded,
    onContainedViewDeleted,
    onContainedViewSelected,
    onContainedViewNameChanged,
    onNavItemNameChanged,
    onNavItemAdded,
    onNavItemSelected,
    onIndexSelected,
    onNavItemExpanded,
    onNavItemDeleted,
    onNavItemsDeleted,
    onNavItemReordered,
    onNavItemDuplicated,
    onNavItemDuplicatedByPayload,
    onTitleChanged,
    onToggleFull,
    onToggleWidth,
    activeLeftPanel,
    hideTab,
    category,
    libraryCategory,
    setcat,
    toggleFileUpload,
    boxSelected,
    onLibraryCategorySelected,
    baseUrl,
    trainingId,
    onNarrationSelect,
    onNarrationDelete,
    onSceneOpen,
    aiPanel, // TODO: Deprecated — "images"/"sounds"/"avatars" değerleri artık modal popup'larla karşılanıyor
    filesUploaded,
    pluginToolbars,
    fileModalResult,
    uploadFunction,
    onNavItemsAdded,
    onReturnToLayers,
    onSetLibraryCategory,
    onReplacePluginFile,
    onShowServerModal,
    ttiGenerateImageFile,
    ttsGenerateSoundFile,
    onAddBox,
    onAddImageModalToggle,
    onAddAvatarModalToggle,
    onAddSoundModalNewToggle,
    onNavItemToggled,
    assessmentCategory,
    onAssessmentCategorySelected,
    onSetAssessmentCategory,
  } = props;
  const isClm = isClmCourse(globalConfig);

  // Scene index multi-selection, owned by FileTree and mirrored here so the
  // bottom Delete button (CarouselButtons) can bulk-delete it.
  const [selectedSceneIds, setSelectedSceneIds] = React.useState([]);

  const isScenesPanel = activeLeftPanel === "layers";
  // Components + Library use a narrow icon+label rail.
  const isNarrowRail = activeLeftPanel === "elementsLibrary" || activeLeftPanel === "library";
  const expandedWidth = `${
    isScenesPanel
      ? LEFT_PANEL_WIDTH.scenes
      : isNarrowRail
        ? LEFT_PANEL_WIDTH.narrowRail
        : LEFT_PANEL_WIDTH.default
  }px`;

  const interactiveBoxSelected =
    !!boxSelected &&
    !!pluginToolbars &&
    !!pluginToolbars[boxSelected] &&
    pluginToolbars[boxSelected].pluginId === "InteractivePlugin";

  const dimClass = interactiveBoxSelected ? "left-rail--interactive-mode" : undefined;
  const renderOverlayPanels = (
    category,
    ai,
    onSelectCategory = onSetLibraryCategory,
    PanelsComponent = LibraryPanels
  ) => {
    // While an InteractivePlugin box is selected the left rails are dimmed and
    // their submenu/overlay must stay closed — never open or auto-open it.
    if (interactiveBoxSelected) return null;
    if (!category && !ai) return null;

    return (
      <>
        {/* Close tab — separate fixed element so it's never clipped by the overlay's stacking context */}
        <button
          onClick={() => {
            onReturnToLayers();
            onToggleWidth();
          }}
          title={i18n.t("close") || "Kapat"}
          style={{
            position: "fixed",
            left: `calc(${expandedWidth} + ${LEFT_PANEL_OVERLAY_WIDTH}px)`,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 100000,
            background: "white",
            border: "1px solid #e2e8f0",
            borderLeft: "none",
            borderRadius: "0 6px 6px 0",
            padding: "12px 5px",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            color: "#6b7280",
            fontSize: "20px",
            boxShadow: "2px 0 8px rgba(0,0,0,0.08)",
          }}
        >
          <LuChevronLeft />
        </button>
        <div
          style={{
            position: "fixed",
            top: "0px",
            left: expandedWidth,
            width: `${LEFT_PANEL_OVERLAY_WIDTH}px`,
            minWidth: `${LEFT_PANEL_OVERLAY_WIDTH}px`,
            height: "100vh",
            background: "#fff",
            overflowY: "visible",
            zIndex: 99999,
            pointerEvents: "auto",
            padding: "10px 0 10px 0",
            borderRight: "1px solid #e2e8f0",
          }}
          className="dndWindow"
        >
          <PanelsComponent
            libraryCategory={category}
            isClm={isClm}
            aiPanel={ai}
            filesUploaded={filesUploaded}
            uploadFunction={uploadFunction}
            onNavItemsAdded={onNavItemsAdded}
            onIndexSelected={onIndexSelected}
            onNavItemSelected={onNavItemSelected}
            navItemsIds={navItemsIds}
            navItems={navItems}
            navItemSelected={navItemSelected}
            containedViews={containedViews}
            containedViewSelected={containedViewSelected}
            boxes={boxes}
            boxSelected={boxSelected}
            pluginToolbars={pluginToolbars}
            fileModalResult={fileModalResult}
            onAddBox={onAddBox}
            onBoxAdded={onBoxAdded}
            onReturnToLayers={onReturnToLayers}
            onSetLibraryCategory={onSelectCategory}
            onReplacePluginFile={onReplacePluginFile}
            onShowServerModal={onShowServerModal}
            ttiGenerateImageFile={ttiGenerateImageFile}
            ttsGenerateSoundFile={ttsGenerateSoundFile}
            baseUrl={baseUrl}
            trainingId={trainingId}
            onNarrationSelect={onNarrationSelect}
            onNarrationDelete={onNarrationDelete}
            onSceneOpen={onSceneOpen}
          />
        </div>
      </>
    );
  };

  return (
    <div
      id="colLeft"
      className="wrapperCarousel"
      style={{
        maxWidth: carouselShow ? (carouselFull ? "100%" : expandedWidth) : "80px",
        overflowX: carouselFull ? "hidden" : "",
        backgroundColor: "white",
        borderRight: "1px solid #e2e8f0",
      }}
    >
      <CarouselHeader
        carouselFull={carouselFull}
        carouselShow={carouselShow}
        courseTitle={globalConfig.title}
        onTitleChanged={onTitleChanged}
        onToggleFull={onToggleFull}
        onToggleWidth={onToggleWidth}
      />
      {(!activeLeftPanel || activeLeftPanel === "layers") && (
        <>
          {/* === Task 22 — SAHNELER label + flow-viewer (⫷) button === */}
          <FileTree
            exercises={exercises}
            globalConfig={globalConfig}
            carouselShow={carouselShow}
            containedViews={containedViews}
            containedViewSelected={containedViewSelected}
            boxes={boxes}
            navItemsIds={navItemsIds}
            navItems={navItems}
            navItemSelected={navItemSelected}
            indexSelected={indexSelected}
            onBoxAdded={onBoxAdded}
            onContainedViewDeleted={onContainedViewDeleted}
            onContainedViewSelected={onContainedViewSelected}
            onContainedViewNameChanged={onContainedViewNameChanged}
            onNavItemNameChanged={onNavItemNameChanged}
            onNavItemAdded={onNavItemAdded}
            onNavItemSelected={onNavItemSelected}
            onIndexSelected={onIndexSelected}
            onNavItemExpanded={onNavItemExpanded}
            onNavItemDeleted={onNavItemDeleted}
            onSceneSelectionChange={setSelectedSceneIds}
            onNavItemReordered={onNavItemReordered}
            viewToolbars={viewToolbars}
            courseTitle={globalConfig.title}
            onTitleChanged={onTitleChanged}
            onToggleWidth={onToggleWidth}
            onClose={onToggleWidth}
            onNavItemToggled={onNavItemToggled}
          />

          <CarouselButtons
            boxes={boxes}
            carouselShow={carouselShow}
            containedViews={containedViews}
            indexSelected={indexSelected}
            navItems={navItems}
            navItemsIds={navItemsIds}
            onNavItemAdded={onNavItemAdded}
            onNavItemReordered={onNavItemReordered}
            onBoxAdded={onBoxAdded}
            onNavItemExpanded={onNavItemExpanded}
            onIndexSelected={onIndexSelected}
            onContainedViewDeleted={onContainedViewDeleted}
            onNavItemDuplicated={onNavItemDuplicated}
            onNavItemDuplicatedByPayload={onNavItemDuplicatedByPayload}
            onNavItemDeleted={onNavItemDeleted}
            selectedSceneIds={selectedSceneIds}
            onNavItemsDeleted={onNavItemsDeleted}
            onNavItemToggled={onNavItemToggled}
            uploadedTemplates={uploadedTemplates}
            isClm={isClm}
          />
        </>
      )}
      {activeLeftPanel === "elementsLibrary" && (
        <div
          data-testid="left-rail-elementsLibrary-wrapper"
          className={dimClass}
          aria-hidden={interactiveBoxSelected ? "true" : undefined}
          style={{ height: "100%" }}
        >
          <ComponentsNav
            selectedCategory={assessmentCategory}
            onCategorySelected={onAssessmentCategorySelected}
            isClm={isClm}
          />
          {renderOverlayPanels(assessmentCategory, null, onSetAssessmentCategory, ComponentsPanels)}
        </div>
      )}
      {activeLeftPanel === "library" && (
        <div
          data-testid="left-rail-library-wrapper"
          className={dimClass}
          aria-hidden={interactiveBoxSelected ? "true" : undefined}
          style={{ height: "100%" }}
        >
          <LibraryPanel
            onCategorySelected={onLibraryCategorySelected}
            selectedCategory={libraryCategory}
          />
          {renderOverlayPanels(libraryCategory, aiPanel)}
        </div>
      )}
      {activeLeftPanel === "audio" && (
        <div
          data-testid="left-rail-audio-wrapper"
          className={dimClass}
          aria-hidden={interactiveBoxSelected ? "true" : undefined}
          style={{ height: "100%" }}
        >
          <AudioPanel
            onAudioOptionSelected={(option) => {
              setSelectedAudioOption(option);
            }}
            selectedOption={selectedAudioOption}
            onClose={onReturnToLayers}
          />
          {renderOverlayPanels(null, selectedAudioOption)}
        </div>
      )}
    </div>
  );
};

export default EditorCarousel;
